import React from 'react'
import { Link } from 'react-router-dom'
import junior from 'assets/images/junior.jpg'
import piacievski from 'assets/images/piacievski.jpg'
import petrassi from 'assets/images/petrassi.jpg'
import teixeira from 'assets/images/teixeira.jpg'

const data = [
  {
    name: 'Dr. José Macias Nogueira Junior',
    specialization: 'Direito Empresarial',
    email: 'exemplo@gmail.com',
    phone: '(00) 0000-0000',
    image: junior,
    oab: '31.848',
    slug: 'jose-macias-nogueira-junior',
  },
  {
    name: 'Dr. Diego Pulzatto Piacievski',
    specialization: 'Direito Civil e Penal',
    email: 'exemplo@gmail.com',
    phone: '(00) 0000-0000',
    image: piacievski,
    oab: '76.292',
    slug: 'diego-pulzatto-piacievski',
  },
  {
    name: 'Dra. Renata Fontes Pereira Teixeira',
    specialization: 'Direito da Família e Civil',
    email: 'exemplo@gmail.com',
    phone: '(00) 0000-0000',
    image: teixeira,
    oab: '60.469',
    slug: 'renata-fontes-pereira-teixeira',
  },
  {
    name: 'Dra. Renata Lima Petrassi',
    specialization: 'Recuperação de Crédito',
    email: 'exemplo@gmail.com',
    phone: '(00) 0000-0000',
    image: petrassi,
    oab: '57.496',
    slug: 'renata-lima-petrassi',
  },
]

const Section = () => {
  return (
    <section id='quem-somos' className='flex w-full flex-col items-center justify-center gap-4 pb-20 pt-28 md:gap-8'>
      <div className='grid w-11/12 grid-cols-1 gap-8 md:w-10/12'>
        {/* Breadcrumb Navigation */}
        <div className='flex items-center gap-2 text-xl'>
          <Link to={'/'} className='transition-all duration-500 hover:text-blue'>
            Home
          </Link>
          <span>/</span>
          <Link to={'/quem-somos'} className='transition-all duration-500 hover:text-blue'>
            Advogados
          </Link>
        </div>

        {/* List of Lawyers */}
        <ul className='m-4 flex items-baseline gap-4 overflow-x-auto md:m-8 md:grid md:grid-cols-4'>
          {data.map((lawyer, index) => (
            <li
              key={index}
              className='flex min-w-52 flex-col items-center justify-center gap-4 text-center opacity-100 md:w-auto'
            >
              {/* O Link agora é montado usando o slug corretamente */}
              <Link to={`/lawyer/${lawyer.slug}`}>
                <img
                  src={lawyer.image}
                  alt={`Foto do advogado ${lawyer.name}`}
                  className='w-full scale-95 cursor-pointer rounded-md shadow-md transition-all duration-500 hover:scale-100'
                  loading='lazy'
                />
              </Link>
              <div className='flex w-10/12 flex-col text-lg md:text-xl'>
                <h3 className='font-semibold'>{lawyer.name}</h3>
                <p className='mb-2'>{`OAB/PR - ${lawyer.oab}`}</p>
                <p className='mb-2'>{`Especialista em ${lawyer.specialization}`}</p>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </section>
  )
}

export default Section